
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
const { mapState } = createNamespacedHelpers(APPLICATION.NAME_SPACE);
export default Vue.extend({
  data() {
    return {};
  },

  computed: {
    ...mapState({
      personalGuaranteeFileLocation: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.creditDetails &&
        state.applicationData.creditDetails.personalGuaranteeFileLocation
    })
  }
});
